/* tslint:disable */

declare var Object: any;
export interface EngagementActivityInterface {
  "sfdcId"?: string;
  "ts2__Contact__c"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "Name"?: string;
  "LastModifiedById"?: string;
  "ts2__Engagement__c"?: string;
  "ts2__Engagement_Stage__c"?: string;
  "ts2__ExternalMessageId__c"?: string;
  "ts2__Recipient_Address__c"?: string;
  "ts2__Status__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class EngagementActivity implements EngagementActivityInterface {
  "sfdcId": string;
  "ts2__Contact__c": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "Name": string;
  "LastModifiedById": string;
  "ts2__Engagement__c": string;
  "ts2__Engagement_Stage__c": string;
  "ts2__ExternalMessageId__c": string;
  "ts2__Recipient_Address__c": string;
  "ts2__Status__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: EngagementActivityInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `EngagementActivity`.
   */
  public static getModelName() {
    return "EngagementActivity";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of EngagementActivity for dynamic purposes.
  **/
  public static factory(data: EngagementActivityInterface): EngagementActivity{
    return new EngagementActivity(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'EngagementActivity',
      plural: 'EngagementActivities',
      path: 'EngagementActivities',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "ts2__Contact__c": {
          name: 'ts2__Contact__c',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "ts2__Engagement__c": {
          name: 'ts2__Engagement__c',
          type: 'string'
        },
        "ts2__Engagement_Stage__c": {
          name: 'ts2__Engagement_Stage__c',
          type: 'string'
        },
        "ts2__ExternalMessageId__c": {
          name: 'ts2__ExternalMessageId__c',
          type: 'string'
        },
        "ts2__Recipient_Address__c": {
          name: 'ts2__Recipient_Address__c',
          type: 'string'
        },
        "ts2__Status__c": {
          name: 'ts2__Status__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
